module.exports = __webpack_public_path__ + "static/media/joffre-6.148f35d3.jpg";